
'use client';

import React from 'react'
// import bgimage from "../../../assets/Image/imgback.png"
// import backimg from "../../../assets/Image/imgback1.png"
// import continents from "../../../assets/Image/imgback2.png"
// import imgback3 from "../../../assets/Image/imgback3.png"
// import maka from "../../../assets/Image/placeimg 1.png"
import slider1 from "../../../assets/Image/home-img/home-slider/slider-image-1.png"
import slider2 from "../../../assets/Image/home-img/home-slider/slider-image-2.png"
import slider3 from "../../../assets/Image/home-img/home-slider/slider-image-3.png"
import slider4 from "../../../assets/Image/home-img/home-slider/slider-image-4.png"
import slider5 from "../../../assets/Image/home-img/our-services/pilgrimage-tour.png"

import Image from 'next/image'
import { HeaderBottomSvg } from '@/assets/icons';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

export const HeaderScreen = () => {

  const images = [
    {
      img: slider1
    },
    {
      img: slider2
    },
    {
      img: slider3
    },
    {
      img: slider4
    },
    {
      img: slider5
    },

  ]
  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    waitForAnimate: false,
    autoplaySpeed: 3000,


    appendDots: (dots: React.ReactNode) => (
      <div className="custom-dots-wrapper ">
        <div className="dots-list">{dots}</div>
      </div>
    ),
    customPaging: () => (
      <div className="dot" />
    ),
  };
  return (
    <div className='relative'>
      <div className="slider-container w-full h-full ">
        <Slider {...settings}>
          {
            images.map((n, i) => {
              return (
                <div className='relative ' key={i}>
                  <Image src={n.img} alt="bg-image" className='w-full h-[70vh] md:h-screen object-cover' />
                  <div style={{
                    background: 'linear-gradient(180deg, rgba(58, 58, 58, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)'
                  }}
                    className='absolute top-0 w-full h-full'
                  >
                  </div>
                </div>
              )
            })
          }


        </Slider>
      </div>

      <div className='absolute top-12 bottom-0 flex flex-col
 items-center justify-center end-0 left-0 text-white text-center px-2' data-aos="fade-up">
        <h1 className='max-w-3xl font-bold  pb-2 xl:text-6xl'><span className='text-[#FFF32A]'>Your Next Adventure</span> Starts Here!</h1>
        <p>Explore the world your way find your perfect adventure with us!</p>
      </div>
      <div className='absolute  bottom-[-13px] md:-bottom-1 end-0 left-0 flex justify-center'>
        <HeaderBottomSvg />
      </div>
    </div>
  )
}
